/**
 * Supported languages configuration
 * Used for language preferences and translations throughout the app
 */

export interface SupportedLanguage {
  code: string
  name: string
  nativeName: string
}

export const I18NEXT_LANGUAGE_STORAGE_KEY = 'i18nextLng' as const

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: 'en', name: 'languagePreferences.english', nativeName: 'English' },
  { code: 'es', name: 'languagePreferences.spanish', nativeName: 'Español' },
  { code: 'ar', name: 'languagePreferences.arabic', nativeName: 'العربية' },
  { code: 'zh_CN', name: 'languagePreferences.simplifiedChinese', nativeName: '简体中文' },
  { code: 'fr', name: 'languagePreferences.french', nativeName: 'Français' },
  { code: 'pt', name: 'languagePreferences.portuguese', nativeName: 'Português' },
  { code: 'ru', name: 'languagePreferences.russian', nativeName: 'Русский' },
  { code: 'tl', name: 'languagePreferences.tagalog', nativeName: 'Tagalog' },
  { code: 'uk', name: 'languagePreferences.ukrainian', nativeName: 'Українська' },
  { code: 'tr', name: 'languagePreferences.turkish', nativeName: 'Türkçe' },
  { code: 'so', name: 'languagePreferences.somali', nativeName: 'Soomaali' },
  { code: 'fa-latn-ir', name: 'languagePreferences.farsiLatinIran', nativeName: 'Farsi (Latin, Iran)' },
  { code: 'ht_HT', name: 'languagePreferences.haitianCreole', nativeName: 'Kreyòl Ayisyen' },
  { code: 'vi', name: 'languagePreferences.vietnamese', nativeName: 'Tiếng Việt' },
  { code: 'ps_AF', name: 'languagePreferences.pashto', nativeName: 'پښتو' },
  { code: 'my', name: 'languagePreferences.burmese', nativeName: 'မြန်မာစာ' },
  { code: 'pa', name: 'languagePreferences.punjabi', nativeName: 'ਪੰਜਾਬੀ' },
  { code: 'sw', name: 'languagePreferences.swahili', nativeName: 'Kiswahili' },
  { code: 'lo_LA', name: 'languagePreferences.lao', nativeName: 'ພາສາລາວ' },
  { code: 'ko', name: 'languagePreferences.korean', nativeName: '한국어' },
  { code: 'ja', name: 'languagePreferences.japanese', nativeName: '日本語' },
  { code: 'am', name: 'languagePreferences.amharic', nativeName: 'አማርኛ' },
  { code: 'chk', name: 'languagePreferences.chuukese', nativeName: 'Fosun Chuuk' },
  { code: 'ne', name: 'languagePreferences.nepali', nativeName: 'नेपाली' },
]

/**
 * Map of language codes to native names for quick lookup
 */
export const LANGUAGE_NAMES: Record<string, string> = SUPPORTED_LANGUAGES.reduce(
  (acc, lang) => {
    acc[lang.code] = lang.nativeName
    return acc
  },
  {} as Record<string, string>
)

/**
 * Get the native name for a language code
 */
export function getLanguageName(code: string): string {
  return LANGUAGE_NAMES[code] || code
}
